import { useQuery } from "@tanstack/react-query";
import { getDashboardCandidates } from "../api/dashboard.api";
import { STALE_2_MIN } from "@/lib/queryKey";

export const dashboardKeys = {
  all: ["dashboard"] as const,
  candidates: () => [...dashboardKeys.all, "candidates"] as const,
};

export const useDashboardCandidates = () =>
  useQuery({
    queryKey: dashboardKeys.candidates(),
    queryFn: getDashboardCandidates,
    ...STALE_2_MIN,
  });
